(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.querySelectorAll('.lyckd-pdp__accordion').forEach((accordion) => {
    const items = [...accordion.querySelectorAll('.lyckd-pdp__accordion-item')];
    const animations = new WeakMap();

    function setOpen(item, expand) {
      const current = animations.get(item);
      const startHeight = item.getBoundingClientRect().height;
      const content = item.querySelector('.lyckd-pdp__accordion-content');
      const startOpacity = item.open ? Number.parseFloat(getComputedStyle(content).opacity) : 0;

      if (current) {
        current.height.cancel();
        current.fade.cancel();
        animations.delete(item);
      }

      item.dataset.expanded = String(expand);
      if (reduceMotion.matches) {
        item.open = expand;
        item.style.height = '';
        item.style.overflow = '';
        return;
      }

      if (expand) item.open = true;

      const endHeight = expand
        ? Math.ceil(item.scrollHeight + item.clientTop)
        : Math.ceil(item.querySelector('summary').getBoundingClientRect().height + item.clientTop);

      item.style.height = `${startHeight}px`;
      item.style.overflow = 'hidden';

      const height = item.animate(
        [{ height: `${startHeight}px` }, { height: `${endHeight}px` }],
        { duration: 300, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
      );
      const fade = content.animate(
        [{ opacity: startOpacity }, { opacity: expand ? 1 : 0 }],
        { duration: expand ? 170 : 100, delay: expand ? 100 : 0, fill: 'both' }
      );

      animations.set(item, { height, fade });
      height.finished.then(() => {
        if (animations.get(item)?.height !== height) return;
        if (!expand) item.open = false;
        item.style.height = '';
        item.style.overflow = '';
        fade.cancel();
        animations.delete(item);
      }).catch(() => {});
    }

    items.forEach((item) => {
      item.dataset.expanded = String(item.open);
      item.querySelector('summary').addEventListener('click', (event) => {
        event.preventDefault();
        const expand = item.dataset.expanded !== 'true';
        if (expand) {
          items.forEach((other) => {
            if (other !== item && other.dataset.expanded === 'true') setOpen(other, false);
          });
        }
        setOpen(item, expand);
      });
    });
  });
})();
